import { render, staticRenderFns } from "./shoppingGuideTask.vue?vue&type=template&id=c15f1fbc&scoped=true"
import script from "./shoppingGuideTask.vue?vue&type=script&lang=js"
export * from "./shoppingGuideTask.vue?vue&type=script&lang=js"
import style0 from "./shoppingGuideTask.vue?vue&type=style&index=0&id=c15f1fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15f1fbc",
  null
  
)

export default component.exports